import { mapPartners } from '@/components/partners/partner'
import { Partner } from '@/types/partner'

export const REAL_ESTATE_PARTNERS: Partner[] = [
  // CHABERT
  {
    id: 'chabert',
    name: 'Chabert Group',
    type: 'real-estate',
    logo: '/partners/chabert-group/chabert-group-logo.jpg',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://chabertgroup.com/fr/',
      en: 'https://chabertgroup.com/en/'
    },
    email: 'isabelle@chabertgroup.com',
    phone: '+33 6 50 34 99 01',
    location: {
      fr: 'Villefranche-sur-Mer',
      en: 'Villefranche-sur-Mer'
    },
    addresses: [{
      countryCode: 'fr',
      area: '06',
      zipCode: '06230',
      city: 'Villefranche-sur-Mer',
      addressLine: '2 Pl de la Paix',
      latitude: 43.704718003026166,
      longitude: 7.310671912718007
    }],
    backgroundImages: [
      '/partners/chabert-group/chabert-group-1.png',
      '/partners/chabert-group/chabert-group-2.png',
      '/partners/chabert-group/chabert-group-3.png'
    ],
    description: {
      fr: 'Une agence familiale mère-fille au coeur de la Riviera',
      en: 'A mother-daughter agency in the heart of the Riviera'
    }
  },
  // EMILE GARCIN
  {
    id: 'emilegarcin',
    name: 'Emile Garcin Propriétés',
    type: 'real-estate',
    logo: '/partners/emile-garcin/emile-garcin-logo.jpg',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://www.emilegarcin.com/fr/',
      en: 'https://www.emilegarcin.com/en/'
    },
    email: '',
    phone: '',
    location: {
      fr: 'Plus de 20 agences dans toute la France',
      en: '20+ agencies throughout France'
    },
    addresses: [{
      countryCode: 'fr',
      area: '06',
      zipCode: '06250',
      city: 'Mougins',
      addressLine: '50 Av Jean-Charles Mallet',
      latitude: 43.60131798383093,
      longitude: 6.995884483158848,
      website: {
        fr: 'https://www.emilegarcin.com/fr/agence-immobilier-luxe/emile-garcin-cote-dazur',
        en: 'https://www.emilegarcin.com/en/agency/emile-garcin-cote-dazur'
      }
    }, {
      countryCode: 'fr',
      area: '13',
      zipCode: '13100',
      city: 'Aix en Provence',
      addressLine: '1 Rue du 4 Septembre',
      latitude: 43.52634875182216,
      longitude: 5.4501814550394645,
      website: {
        fr: 'https://www.emilegarcin.com/fr/agence-immobilier-luxe/emile-garcin-aix-en-provence',
        en: 'https://www.emilegarcin.com/en/agency/emile-garcin-aix-en-provence'
      }
    }, {
      countryCode: 'fr',
      area: '30',
      zipCode: '30700',
      city: 'Uzès',
      addressLine: '2 Pl de l’Evêché',
      latitude: 44.012788091592,
      longitude: 4.421642482042163,
      website: {
        fr: 'https://www.emilegarcin.com/fr/agence-immobilier-luxe/emile-garcin-cevennes-et-languedoc',
        en: 'https://www.emilegarcin.com/en/agency/emile-garcin-cevennes-et-languedoc'
      }
    }, {
      countryCode: 'fr',
      area: '75',
      zipCode: '75008',
      city: 'Paris',
      addressLine: '24 Rue du Boccador',
      latitude: 48.86760523528198,
      longitude: 2.3017414552501236,
      website: {
        fr: 'https://www.emilegarcin.com/fr/agence-immobilier-luxe/emile-garcin-paris-rive-droite',
        en: 'https://www.emilegarcin.com/en/agency/emile-garcin-paris-rive-droite'
      }
    }, {
      countryCode: 'fr',
      area: '83',
      zipCode: '83990',
      city: 'Saint-Tropez',
      addressLine: '19 Pl du 15eme Corps',
      latitude: 43.2689618881361,
      longitude: 6.639803619044912,
      website: {
        fr: 'https://www.emilegarcin.com/fr/agence-immobilier-luxe/emile-garcin-saint-tropez-et-littoral',
        en: 'https://www.emilegarcin.com/en/agency/emile-garcin-saint-tropez-et-littoral'
      }
    }],
    backgroundImages: [
      '/partners/emile-garcin/emile-garcin-1.jpg',
      '/partners/emile-garcin/emile-garcin-2.jpg',
      '/partners/emile-garcin/emile-garcin-3.jpg'
    ],
    description: {
      fr: 'L’immobilier de caractère',
      en: 'Authentic Real Estate'
    }
  },
  // RIVIERA PRESTIGE
  {
    id: 'rivieraprestige',
    name: 'Riviera Prestige',
    type: 'real-estate',
    logo: '/partners/riviera-prestige/riviera-prestige-logo.jpg',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://www.rivieraprestige.fr/fr/',
      en: 'https://www.rivieraprestige.fr/en/'
    },
    email: 'contact@rivieraprestige.fr',
    phone: '+33 6 62 98 27 46',
    location: {
      fr: 'Cannes',
      en: 'Cannes'
    },
    addresses: [{
      countryCode: 'fr',
      area: '06',
      zipCode: '06400',
      city: 'Cannes',
      addressLine: '49 Bd Montfleury',
      latitude: 43.55603576625087,
      longitude: 7.032857140818573
    }],
    backgroundImages: [
      '/partners/riviera-prestige/riviera-prestige-1.jpg',
      '/partners/riviera-prestige/riviera-prestige-2.jpg',
      '/partners/riviera-prestige/riviera-prestige-3.jpg'
    ],
    description: {
      fr: '',
      en: ''
    }
  },
  // MAGREY & SONS
  {
    id: 'magrey',
    name: 'Magrey & Sons',
    type: 'real-estate',
    logo: '/partners/magrey-and-sons/magrey-and-sons-logo.png',
    logoDark: '/partners/magrey-and-sons/magrey-and-sons-logo-dark.jpg',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://www.magrey.fr/',
      en: 'https://www.magrey.com/'
    },
    email: 'cannes@magrey.com',
    phone: '+33 4 92 98 98 22',
    location: {
      fr: '5 agences sur la Côte d’Azur & Paris',
      en: '5 agencies on the French Riviera & Paris'
    },
    addresses: [{
      countryCode: 'fr',
      area: '06',
      zipCode: '06400',
      city: 'Cannes',
      addressLine: '9 Bd de la Croisette',
      latitude: 43.55130091966094,
      longitude: 7.01947015504039,
      website: {
        fr: 'https://www.magrey.fr/agences/agence-cannes',
        en: 'https://www.magrey.com/agencies/cannes-agency'
      }
    }, {
      countryCode: 'fr',
      area: '06',
      zipCode: '06250',
      city: 'Mougins',
      addressLine: '68 Pl du Cdt Lamy',
      latitude: 43.60099861836396,
      longitude: 6.994581882026671,
      website: {
        fr: 'https://www.magrey.fr/agences/agence-mougins',
        en: 'https://www.magrey.com/agencies/mougins-agency'
      }
    }, {
      countryCode: 'fr',
      area: '06',
      zipCode: '06560',
      city: 'Valbonne',
      addressLine: '25 Rue Emile Pourcel',
      latitude: 43.64165141827563,
      longitude: 7.007930439700057,
      website: {
        fr: 'https://www.magrey.fr/agences/agence-valbonne',
        en: 'https://www.magrey.com/agencies/valbonne-agency'
      }
    }, {
      countryCode: 'fr',
      area: '75',
      zipCode: '75007',
      city: 'Paris',
      addressLine: '101 Rue du Bac',
      latitude: 48.85308886129875, 
      longitude: 2.323774311069849,
      website: {
        fr: 'https://www.magrey.fr/agences/agence-paris',
        en: 'https://www.magrey.com/agencies/paris-agency'
      }
    }, {
      countryCode: 'fr',
      area: '83',
      zipCode: '83990',
      city: 'Saint-Tropez',
      addressLine: '56 Bd Louis Blanc',
      latitude: 43.269710600128384,
      longitude: 6.63766661270175,
      website: {
        fr: 'https://www.magrey.fr/agences/agence-saint-tropez',
        en: 'https://www.magrey.com/agencies/saint-tropez-agency'
      }
    }],
    backgroundImages: [
      '/partners/magrey-and-sons/magrey-and-sons-1.jpg',
      '/partners/magrey-and-sons/magrey-and-sons-2.jpg',
      '/partners/magrey-and-sons/magrey-and-sons-3.jpg'
    ],
    description: {
      fr: 'L’art de vivre by Magrey & Sons',
      en: 'Discover the lifestyle'
    }
  },
  // CANNISIMMO
  {
    id: 'cannisimmo',
    name: 'CannisImmo',
    type: 'real-estate',
    logo: '/partners/cannisimmo/cannissimo-logo.png',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://cannisimmo.com/fr/',
      en: 'https://cannisimmo.com/en/'
    },
    email: 'info@cannisimmo.com',
    phone: '+33 4 92 19 62 55',
    location: {
      fr: 'Cannes Forville – Bocca Sud – Mandelieu',
      en: 'Cannes Forville – Bocca Sud – Mandelieu'
    },
    addresses: [{
      countryCode: 'fr',
      area: '06',
      zipCode: '06400',
      city: 'Cannes',
      addressLine: '12 Rue Louis Blanc',
      latitude: 43.55255878155332,
      longitude: 7.013120312712336
    }
    ],
    backgroundImages: [
      '/partners/cannisimmo/cannissimo-1.jpeg',
      '/partners/cannisimmo/cannissimo-2.jpeg',
      '/partners/cannisimmo/cannissimo-3.jpeg'
    ],
    description: {
      fr: 'Votre Confiance, Notre Réussite !',
      en: 'Your Trust, Our Success!'
    }
  },
  // IMPACT
  {
    id: 'impact',
    name: 'Impact',
    type: 'real-estate',
    logo: '/partners/impact/impact-logo.png',
    logoDark: '/partners/impact/impact-logo.png',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://cannes-impact.com/fr/',
      en: 'https://cannes-impact.com/en/'
    },
    email: 'sales@cannes-impact.com',
    phone: '+33 4 93 30 13 13',
    location: {
      fr: 'Cannes',
      en: 'Cannes'
    },
    addresses: [{
      countryCode: 'fr',
      area: '06',
      zipCode: '06400',
      city: 'Cannes',
      addressLine: '45 Bd de La Croisette',
      latitude: 43.550043338718524,
      longitude: 7.023982341548068
    }],
    backgroundImages: [
      '/partners/impact/impact-1.jpg',
      '/partners/impact/impact-2.jpg',
      '/partners/impact/impact-3.jpg'
    ],
    description: {
      fr: 'Spécialiste de l’immobilier de prestige depuis 1985',
      en: 'Experts in luxury real estate since 1985'
    }
  },
  // INTUITION
  {
    id: 'intuition',
    name: 'Intuition',
    type: 'real-estate',
    logo: '/partners/intuition/intuition-logo.jpg',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://intuition.immo/fr/',
      en: 'https://intuition.immo/en/'
    },
    email: 'contact@intuition.immo',
    phone: '+33 4 93 39 50 80',
    location: {
      fr: 'Cannes',
      en: 'Cannes'
    },
    addresses: [{
      countryCode: 'fr',
      area: '06',
      zipCode: '06400',
      city: 'Cannes',
      addressLine: '13 Rue des États-Unis',
      latitude: 43.55171211190051,
      longitude: 7.021753783145595
    }],
    backgroundImages: [
      '/partners/intuition/intuition-1.jpg',
      '/partners/intuition/intuition-2.jpg',
      '/partners/intuition/intuition-3.jpg'
    ],
    description: {
      fr: 'Une agence indépendante et à taille humaine',
      en: 'An independent, people-focused agency'
    }
  },
  // MARCLE
  {
    id: 'marcle',
    name: 'Marclé',
    type: 'real-estate',
    logo: '/partners/marcle/marcle-logo.png',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://marcleimmo.fr/fr/',
      en: 'https://marcleimmo.fr/en/'
    },
    email: 'contact@marcleimmo.fr',
    phone: '+33 4 93 39 00 64',
    location: {
      fr: 'Cannes',
      en: 'Cannes'
    },
    addresses: [{
      countryCode: 'fr',
      area: '06',
      zipCode: '06400',
      city: 'Cannes',
      addressLine: '46 Rue d’Antibes',
      latitude: 43.5525874111177,
      longitude: 7.019700970384161
    }],
    backgroundImages: [
      '/partners/marcle/marcle-1.jpg',
      '/partners/marcle/marcle-2.jpg',
      '/partners/marcle/marcle-3.jpg'
    ],
    description: {
      fr: '',
      en: ''
    }
  },
  // LA CREMERIE
  {
    id: 'lacremerie',
    name: 'Groupe La Crèmerie',
    type: 'real-estate',
    logo: '/partners/la-cremerie/la-cremerie-logo.jpg',
    logoDark: '/partners/la-cremerie/la-cremerie-logo.jpg',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://lacremerie-immobilier.fr/',
      en: 'https://lacremerie-immobilier.fr/en/'
    },
    email: 'contact@lacremerie-immobilier.fr',
    phone: '+33 7 69 60 81 81',
    location: {
      fr: 'Sainte-Maxime – Saint-Raphaël – Bordeaux',
      en: 'Sainte-Maxime – Saint-Raphael – Bordeaux'
    },
    addresses: [{
      countryCode: 'fr',
      area: '33',
      zipCode: '33400',
      city: 'Talence',
      addressLine: '13 Cours Gambetta',
      latitude: 44.820952653088284,
      longitude: -0.5832435449114529,
      website: {
        fr: 'https://lacremerie-immobilier.fr/agency/agence-bordeaux/',
        en: 'https://lacremerie-immobilier.fr/en/agency/agence-bordeaux/'
      }
    }, {
      countryCode: 'fr',
      area: '83',
      zipCode: '83120',
      city: 'Sainte-Maxime',
      addressLine: '32 Av Jean Jaurès',
      latitude: 43.30945781708055,
      longitude: 6.635842597359508,
      website: {
        fr: 'https://lacremerie-immobilier.fr/agency/agence-signature-de-saint-maxime/',
        en: 'https://lacremerie-immobilier.fr/en/agency/agence-signature-de-saint-maxime/'
      }
    }, {
      countryCode: 'fr',
      area: '83',
      zipCode: '83700',
      city: 'Saint-Raphaël',
      addressLine: '115 Rue Jule Barbier',
      latitude: 43.4224621195149,
      longitude: 6.768827168527784,
      website: {
        fr: 'https://lacremerie-immobilier.fr/agency/agence-saint-raphael/',
        en: 'https://lacremerie-immobilier.fr/en/agency/agence-saint-raphael/'
      }
    }],
    backgroundImages: [
      '/partners/la-cremerie/la-cremerie-1.jpg',
      '/partners/la-cremerie/la-cremerie-2.jpg',
      '/partners/la-cremerie/la-cremerie-3.jpg'
    ],
    description: {
      fr: 'L’immobilier Clés en Main !',
      en: 'Turnkey real estate, your way!'
    }
  },
  // SOTHEBY'S COTE D'AZUR
  {
    id: 'sothebyscotedazur',
    name: 'Côte d’Azur Sotheby’s',
    type: 'real-estate',
    logo: '/partners/sothebys-cotedazur/sothebys-cotedazur-logo.jpg',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://www.cotedazur-sothebysrealty.com/fr/',
      en: 'https://www.cotedazur-sothebysrealty.com/en/'
    },
    email: 'info@cotedazur-sothebysrealty.com',
    phone: '+33 4 92 92 12 88',
    location: {
      fr: 'St-Tropez – Cannes – Nice - Beaulieu / Mer - St Jean Cap Ferrat',
      en: 'St-Tropez – Cannes – Nice - Beaulieu / Mer - St Jean Cap Ferrat'
    },
    addresses: [{
      countryCode: 'fr',
      area: '06',
      zipCode: '06310',
      city: 'Beaulieu sur Mer',
      addressLine: '37 Bd Marinoni',
      latitude: 43.707876605234695,
      longitude: 7.331149526210339,
      website: {
        fr: 'https://www.cotedazur-sothebysrealty.com/fr/agences/details/2/agence-immobiliere-luxe-beaulieu/',
        en: 'https://www.cotedazur-sothebysrealty.com/en/agencies/details/2/luxury-real-estate-agency-beaulieu/'
      }
    }, {
      countryCode: 'fr',
      area: '06',
      zipCode: '06400',
      city: 'Cannes',
      addressLine: '74 Bd de la Croisette',
      latitude: 43.54803351096814,
      longitude: 7.031377694785263,
      website: {
        fr: 'https://www.cotedazur-sothebysrealty.com/fr/agences/details/1/agence-immobiliere-luxe-cannes/',
        en: 'https://www.cotedazur-sothebysrealty.com/en/agencies/details/1/luxury-real-estate-agency-cannes/'
      }
    }, {
      countryCode: 'fr',
      area: '06',
      zipCode: '06085',
      city: 'Mougins',
      addressLine: '300 Av de Tournamy',
      latitude: 43.60026974945899,
      longitude: 6.986246654963784,
      website: {
        fr: 'https://www.cotedazur-sothebysrealty.com/fr/agences/details/6/agence-immobiliere-luxe-mougins/',
        en: 'https://www.cotedazur-sothebysrealty.com/en/agencies/details/6/luxury-real-estate-agency-mougins/'
      }
    }, {
      countryCode: 'fr',
      area: '06',
      zipCode: '06000',
      city: 'Nice',
      addressLine: '5 Rue Longchamp',
      latitude: 43.69900940578413,
      longitude: 7.267098097374035,
      website: {
        fr: 'https://www.cotedazur-sothebysrealty.com/fr/agences/details/5/agence-immobiliere-luxe-nice/',
        en: 'https://www.cotedazur-sothebysrealty.com/en/agencies/details/5/luxury-real-estate-agency-nice/'
      }
    }, {
      countryCode: 'fr',
      area: '06',
      zipCode: '06230 ',
      city: 'Saint-Jean-Cap-Ferrat',
      addressLine: '3 Av Denis Semeria',
      latitude: 43.68959941420897,
      longitude: 7.33339388388144,
      website: {
        fr: 'https://www.cotedazur-sothebysrealty.com/fr/agences/details/3/agence-immobiliere-luxe-cap-ferrat/',
        en: 'https://www.cotedazur-sothebysrealty.com/en/agencies/details/3/luxury-real-estate-agency-cap-ferrat/'
      }
    }, {
      countryCode: 'fr',
      area: '83',
      zipCode: '83990 ',
      city: 'Saint-Tropez',
      addressLine: '9 Av Paul Roussel',
      latitude: 43.26897438827226,
      longitude: 6.638395198413693,
      website: {
        fr: 'https://www.cotedazur-sothebysrealty.com/fr/agences/details/4/agence-immobiliere-luxe-saint-tropez/',
        en: 'https://www.cotedazur-sothebysrealty.com/en/agencies/details/4/luxury-real-estate-agency-st-tropez/'
      }
    }],
    backgroundImages: [
      '/partners/sothebys-cotedazur/sothebys-cotedazur-1.jpg',
      '/partners/sothebys-cotedazur/sothebys-cotedazur-2.jpg',
      '/partners/sothebys-cotedazur/sothebys-cotedazur-3.jpg'
    ],
    description: {
      fr: 'l’Immobilier de Luxe sur la Côte d’Azur',
      en: 'Luxury Real Estate on the Côte d’Azur.'
    }
  },
  // VICTOIRE PROPRIETES
  {
    id: 'victoireproprietes',
    name: 'Victoire Propriétés',
    type: 'real-estate',
    logo: '/partners/victoire-proprietes/victoire-proprietes-logo.png',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://victoireproprietes.com',
      en: 'https://victoireproprietes.com'
    },
    email: 'contact@victoireproprietes.com',
    phone: '+33 6 98 47 77 52',
    location: {
      fr: 'Cassis',
      en: 'Cassis'
    },
    addresses: [{
      countryCode: 'fr',
      area: '13',
      zipCode: '13260',
      city: 'Cassis',
      addressLine: '2 Pl Baragnon',
      latitude: 43.21429845436041,
      longitude: 5.539355798159022
    }],
    backgroundImages: [
      '/partners/victoire-proprietes/victoire-proprietes-1.jpeg',
      '/partners/victoire-proprietes/victoire-proprietes-2.jpeg',
      '/partners/victoire-proprietes/victoire-proprietes-3.jpeg'
    ],
    description: {
      fr: 'Agence immobilière familiale',
      en: 'Family real estate agency'
    }
  },
  // LC RIVIERA PROPERTIES
  {
    id: 'lcrivieraproperties',
    name: 'LC Riviera Properties',
    type: 'real-estate',
    logo: '/partners/lc-riviera-properties/lc-riviera-properties-logo.png',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://www.lc-riviera.com',
      en: 'https://www.lc-riviera.com/en'
    },
    email: 'contact@lc-riviera.com',
    phone: '+33 4 22 73 74 67',
    location: {
      fr: 'Saint-Raphaël',
      en: 'Saint-Raphaël'
    },
    addresses: [{
      countryCode: 'fr',
      area: '83',
      zipCode: '83700',
      city: 'Saint-Raphaël',
      addressLine: '47 Rue de la Liberté',
      latitude: 43.42521631242465,
      longitude: 6.769587455035699
    }],
    backgroundImages: [
      '/partners/lc-riviera-properties/lc-riviera-properties-1.jpg',
      '/partners/lc-riviera-properties/lc-riviera-properties-2.jpg',
      '/partners/lc-riviera-properties/lc-riviera-properties-3.jpg'
    ],
    description: {
      fr: 'La meilleure façon de prédire l’avenir, c’est de le créer',
      en: 'The best way to predict the future is to create it'
    }
  },
  // CITYLIFE ARCACHON
  {
    id: 'citylifearcachon',
    name: 'Citylife Arcachon',
    type: 'real-estate',
    logo: '/partners/citylife-arcachon/citylife-arcachon-logo.png',
    logoDark: '/partners/citylife-arcachon/citylife-arcachon-logo.png',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://arcachon.citylife.fr/fr',
      en: 'https://arcachon.citylife.fr/fr'
    },
    email: 'arcachon@citylife.fr',
    phone: '+33 5 57 52 77 11',
    location: {
      fr: 'Arcachon',
      en: 'Arcachon'
    },
    addresses: [{
      countryCode: 'fr',
      area: '33',
      zipCode: '33120',
      city: 'Arcachon',
      addressLine: '41 Av Lamartine',
      latitude: 44.661599362290886,
      longitude: -1.168231244917615
    }],
    backgroundImages: [
      '/partners/citylife-arcachon/citylife-arcachon-1.png',
      '/partners/citylife-arcachon/citylife-arcachon-2.jpg',
      '/partners/citylife-arcachon/citylife-arcachon-3.jpg'
    ],
    description: {
      fr: 'Votre projet immobilier, Notre priorité',
      en: 'Your real estate project, Our priority'
    }
  },
  // LE CASTEL REAL ESTATE
  {
    id: 'lecastel',
    name: 'Le Castel Real Estate',
    type: 'real-estate',
    logo: '/partners/le-castel/le-castel-logo.png',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://www.lecastelrealestate.com/',
      en: 'https://www.lecastelrealestate.com/'
    },
    email: 'agence@lecastelrealestate.com',
    phone: '+33 4 42 04 19 59',
    location: {
      fr: 'La Ciotat',
      en: 'La Ciotat'
    },
    addresses: [{
      countryCode: 'fr',
      area: '13', 
      zipCode: '13600',
      city: 'La Ciotat',
      addressLine: '14 Rue Marius Monnet',
      latitude: 43.1736530,
      longitude: 5.6051550
    }],
    backgroundImages: [
      '/partners/le-castel/background-1.jpg',
      '/partners/le-castel/background-2.jpeg',
      '/partners/le-castel/background-3.jpeg'
    ],
    description: {
      fr: '',
      en: ''
    }
  },
  // CARLTON INTERNATIONAL
  {
    id: 'carlton',
    name: 'Carlton International',
    type: 'real-estate',
    logo: '/partners/carlton-international/carlton-international-logo.png',
    logoDark: '/partners/carlton-international/carlton-international-logo.png',
    logoW: 150,
    logoH: 150,
    website: {
      fr: 'https://www.carlton-international.com/',
      en: 'https://www.carlton-international.com/en/'
    },
    email: 'info@carlton-group.com',
    phone: '+33 4 93 95 11 11',
    location: {
      fr: '7 agences sur la Côte d’Azur & Strasbourg',
      en: '7 agencies on the French Riviera & Strasbourg'
    },
    addresses: [{
      countryCode: 'fr',
      area: '06', 
      zipCode: '06400',
      city: 'Cannes',
      addressLine: '9 Rdpt Duboys d’Angers',
      latitude: 43.551551786802584,
      longitude: 7.0261259973923345,
      website: {
        fr: 'https://www.carlton-international.com/agence/agence-immobilier-cannes/',
        en: 'https://www.carlton-international.com/en/agence/cannes/'
      }
    }, {
      countryCode: 'fr',
      area: '06', 
      zipCode: '06560',
      city: 'Valbonne',
      addressLine: '1240 Rte des dolines',//Buropolis 2
      latitude: 43.62540854321197,
      longitude: 7.040933552401158,
      website: {
        fr: 'https://www.carlton-international.com/agence/mougins-arriere-pays-cannois/',
        en: 'https://www.carlton-international.com/en/agence/mougins-arriere-pays-cannois/'
      }
    }, {
      countryCode: 'fr',
      area: '06', 
      zipCode: '06230',
      city: 'Saint-Jean-Cap-Ferrat',
      addressLine: '3 Av Claude Vignon',
      latitude: 43.688762148150055,
      longitude: 7.333805027792139,
      website: {
        fr: 'https://www.carlton-international.com/agence/saint-jean-cap-ferrat/',
        en: 'https://www.carlton-international.com/en/agence/saint-jean-cap-ferrat/'
      }
    }, {
      countryCode: 'fr',
      area: '06', 
      zipCode: '06570',
      city: 'Saint-Paul-de-Vence',
      addressLine: '1119 Rte de la Colle',
      latitude: 43.69947827462576,
      longitude: 7.1094317108905996,
      website: {
        fr: 'https://www.carlton-international.com/agence/saint-paul-de-vence/',
        en: 'https://www.carlton-international.com/en/agence/saint-paul-de-vence/'
      }
    }, {
      countryCode: 'fr',
      area: '06', 
      zipCode: '06560',
      city: 'Valbonne',
      addressLine: '2555 Rte de Biot',
      latitude: 43.64340818400687,
      longitude: 7.052863154013084,
      website: {
        fr: 'https://www.carlton-international.com/agence/valbonne/',
        en: 'https://www.carlton-international.com/en/agence/valbonne/'
      }
    }, {
      countryCode: 'fr',
      area: '67', 
      zipCode: '67000',
      city: 'Strasbourg',
      addressLine: '4 Pl de Bordeaux',
      latitude: 48.59332940418172,
      longitude: 7.757555855255184,
      website: {
        fr: 'https://www.carlton-international.com/agence/strasbourg/',
        en: 'https://www.carlton-international.com/en/agence/strasbourg/'
      }
    }, {
      countryCode: 'fr',
      area: '83', 
      zipCode: '83990',
      city: 'Saint-Tropez',
      addressLine: '3 Pl Raphaël de Garezzio',//Château de Suffren
      latitude: 43.27338919267767,
      longitude: 6.6392803838894405,
      website: {
        fr: 'https://www.carlton-international.com/agence/saint-tropez/',
        en: 'https://www.carlton-international.com/en/agence/saint-tropez/'
      }
    }, {
      countryCode: 'fr',
      area: '83', 
      zipCode: '83680',
      city: 'La Garde-Freinet',
      addressLine: '34 Rue Saint Jaques',
      latitude: 43.31676530339045,
      longitude: 6.4701596550552924,
      website: {
        fr: 'https://www.carlton-international.com/agence/la-garde-freinet/',
        en: 'https://www.carlton-international.com/en/agence/la-garde-freinet/'
      }
    }],
    backgroundImages: [
      '/partners/carlton-international/carlton-international-1.jpg',
      '/partners/carlton-international/carlton-international-2.jpg',
      '/partners/carlton-international/carlton-international-3.jpg'
    ],
    description: {
      fr: '',
      en: ''
    }
  }
]
export const REAL_ESTATE_PARTNERS_MAP: {[partnerId: string]: Partner} = mapPartners(REAL_ESTATE_PARTNERS)